import { FaRegBuilding } from "react-icons/fa";
import { LuMapPin } from "react-icons/lu";

// Format date helper
export const formatDate = (dateString) => {
  if (!dateString) return "-";
  const formattedStr = typeof dateString === "string" ? dateString.replace(" ", "T") : dateString;
  const date = new Date(formattedStr);
  if (isNaN(date.getTime())) return dateString;
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

// Format date & time helper
export const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  const formattedStr = typeof dateString === "string" ? dateString.replace(" ", "T") : dateString;
  const date = new Date(formattedStr);
  if (isNaN(date.getTime())) return dateString;
  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// Get view modal sections
export const getViewModalSections = (company) => {
  if (!company) return [];

  return [
    {
      title: "Company Information",
      icon: FaRegBuilding,
      iconBg: "bg-blue-100 dark:bg-blue-900/30",
      iconColor: "text-blue-600 dark:text-blue-400",
      fields: [
        { label: "Company Name", value: company.companyName || "-" },
        { label: "Access Code", value: company.accessCompanyCode || "-" },
        { label: "Email", value: company.companyEmail || "-" },
        { label: "Phone", value: company.mobileNumber ? `${company.mobileCode || ""} ${company.mobileNumber}`.trim() : "-" },
        { label: "Website", value: company.companyWebsite || "-" },
        { label: "Industry", value: company.industry || "-" },
        { label: "Company Size", value: company.companySize || "-" },
        { label: "GST Number", value: company.gstNo || "-" },
        { label: "Created Date", value: formatDate(company.createdAt) },
        ...((company.companyRecentActivity || company.recentActivity || company.recent_activity) ? [
          { label: "Company Recent Activity", value: formatDateTime(company.companyRecentActivity || company.recentActivity || company.recent_activity) }
        ] : []),
        ...(company.employeeRecentActivity ? [
          { label: "Employee Recent Activity", value: formatDateTime(company.employeeRecentActivity) }
        ] : []),
        ...(company.employeeStats ? [
          { label: "Workforce", value: `${company.employeeStats.totalEmployees ?? 0} Employees (${company.employeeStats.activeEmployees ?? 0} Active, ${company.employeeStats.deactiveEmployees ?? 0} Inactive)` }
        ] : []),
        {
          label: "Status",
          value: company.isActive ? "Active" : "Suspended",
          badge: true,
          badgeClass:
            company.isActive
              ? "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400"
              : "bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300",
        },
      ],
    },
    {
      title: "Address Details",
      icon: LuMapPin,
      iconBg: "bg-purple-100 dark:bg-purple-900/30",
      iconColor: "text-purple-600 dark:text-purple-400",
      fields: [
        { label: "Address Line 1", value: company.companyAddress?.addressLine1 || "-", fullWidth: true },
        { label: "Address Line 2", value: company.companyAddress?.addressLine2 || "-", fullWidth: true },
        { label: "City", value: company.companyAddress?.city || "-" },
        { label: "State", value: company.companyAddress?.state || "-" },
        { label: "Country", value: company.companyAddress?.country || "-" },
        { label: "Zip Code", value: company.companyAddress?.zipCode || "-" },
      ],
    },
  ];
};
